module.exports = __webpack_public_path__ + "static/media/nolistassessment.d462c25f.svg";